import { Link } from 'react-router-dom'
import { Home, Book, Folder, Heart, Calendar, ShoppingCart, Compass, Plus, LogOut } from 'react-feather'
import SidebarLink from '../components/SidebarLink'
import { useAuth, signOut } from '../lib/auth'
import { useT, userDisplayName } from '@reciperoll/core'

// The sidebar's inner content — brand, nav, and account row. Shared by the
// desktop sidebar (`<aside>`) and the mobile drawer so they never drift.
export default function SidebarContent() {
  const t = useT()
  const { session } = useAuth()
  const email = session?.user.email ?? undefined
  // Editable display name from auth metadata (userDisplayName prefers
  // display_name over the provider-set full_name); fall back to the email.
  const fullName = userDisplayName(session?.user.user_metadata)
  const displayName = fullName || email || 'Account'

  return (
    <>
      <Link to="/" className="px-6 pt-7 pb-6 block">
        <img src="/logo.png" alt="RecipeRoll" className="h-12 w-auto mx-auto" />
      </Link>

      <nav className="flex-1 min-h-0 overflow-y-auto px-6 flex flex-col gap-1 mt-2">
        <SidebarLink to="/" icon={<Home className="w-[18px] h-[18px]" />} label={t("nav.home")} />
        <SidebarLink to="/recipes" icon={<Book className="w-[18px] h-[18px]" />} match={["/recipe"]} label={t("nav.recipes")} />
        <SidebarLink to="/collections" icon={<Folder className="w-[18px] h-[18px]" />} match={["/collection"]} label={t("nav.collections")} />
        <SidebarLink to="/favourites" icon={<Heart className="w-[18px] h-[18px]" />} label={t("nav.favourites")} />
        <SidebarLink to="/meal-plan" icon={<Calendar className="w-[18px] h-[18px]" />} label={t("nav.mealPlanner")} />
        <SidebarLink to="/shopping-list" icon={<ShoppingCart className="w-[18px] h-[18px]" />} label={t("nav.shoppingList")} />
        <SidebarLink to="/what-can-i-make" icon={<Compass className="w-[18px] h-[18px]" />} label={t("nav.whatCanIMake")} />

        <Link to="/recipes/new" className="mt-5 flex items-center justify-center gap-2 bg-terracotta hover:bg-terracotta-dark transition-colors text-white rounded-xl py-3 text-sm font-bold shadow-[0_4px_14px_rgba(224,122,95,0.35)]">
          <Plus className="w-4 h-4" strokeWidth={2.5} />
          {t("nav.newRecipe")}
        </Link>
      </nav>

      <div className="flex items-center gap-3 px-6 py-4 border-t border-line shrink-0">
        <Link to="/settings" title="Account settings" className="flex items-center gap-3 flex-1 min-w-0 rounded-lg hover:opacity-80 transition-opacity">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-terracotta to-[#F4A261] flex items-center justify-center shrink-0"><span className="font-display text-xs font-extrabold text-white uppercase">{displayName[0] ?? "?"}</span></div>
          <span className="min-w-0 text-sm font-semibold text-ink truncate">{displayName}</span>
        </Link>
        <button onClick={() => signOut()} title="Sign out" aria-label="Sign out" className="shrink-0 text-ink-faint hover:text-ink cursor-pointer">
          <LogOut className="w-5 h-5" />
        </button>
      </div>
    </>
  )
}
